<template>
  <!-- eslint-disable vue/no-v-html -->

  <div class="auth-wrapper d-flex align-center justify-center pa-4">
    <VCard
      class="auth-card pa-4 pt-7"
      max-width="448"
      elevation="2"
      outlined="grey-darken-3"
    >
      <VCardItem class="justify-center">
        <!-- eslint-disable vue/no-v-html -->
        <div class="d-flex" v-html="logo" />
        <h2 class="font-weight-medium text-2xl text-uppercase">
          Event Manager
        </h2>
      </VCardItem>

      <VCardText class="pt-2">
        <h4 class="text-h4 mb-1 text-center">Welcome to Event Manager!</h4>
        <p class="my-2 text-center">
          Please enter your email and password to access your account.
        </p>
      </VCardText>

      <VCardText>
        <VForm @submit.prevent="() => {}">
          <VRow>
            <!-- email -->
            <VCol cols="12">
              <VTextField v-model="form.email" label="Email" type="email" />
            </VCol>

            <!-- password -->
            <VCol cols="12">
              <VTextField
                v-model="form.password"
                label="Password"
                placeholder="············"
                :type="isPasswordVisible ? 'text' : 'password'"
                autocomplete="password"
                :append-inner-icon="
                  isPasswordVisible ? 'mdi-eye-off' : 'mdi-eye'
                "
                @click:append-inner="isPasswordVisible = !isPasswordVisible"
              />

              <!-- errors -->
              <div
                class="d-flex align-center justify-space-between flex-wrap my-6"
              >
                {{ error }}
              </div>

              <!-- login button -->
              <VBtn block type="submit" @click="login" color="grey-darken-3">
                Login
              </VBtn>
            </VCol>
          </VRow>
        </VForm>
      </VCardText>
    </VCard>
  </div>
</template>


<script>
import axios from "axios";

export default {
  data() {
    return {
      email: "",
      password: "",
      isPasswordVisible: false,
      form: {
        email: "",
        password: "",
        remember: false,
      },
      logo: "",
      error: null,
    };
  },
  methods: {
    async login() {
      try {
        axios
          .post("/auth/login", {
            email: this.form.email,
            password: this.form.password,
          })
          .then((response) => {
            console.log("Login successful:", response.data);
            localStorage.setItem("token", response.data.token);
            localStorage.setItem('user', JSON.stringify(response.data.user));
            this.$router.push("/home"); // or wherever you want
          })
          .catch((error) => {
            console.error("Login error:", error);
            this.error = error || "Login failed";
          });
      } catch (err) {
        this.error = "Login failed";
      }
    },
  },
};
</script>